module.exports = __webpack_public_path__ + "static/media/I2.1372879d.jpg";